import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ProfileIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 70 70"
        {...props}
      >
        <circle
          cx={-2539.45}
          cy={-6492.74}
          r={9.6}
          fill="none"
          transform="translate(2574.43 6516.827)"
        />
        <path d="M34.98 33.687c-5.29 0-9.6-4.31-9.6-9.6s4.31-9.6 9.6-9.6 9.6 4.31 9.6 9.6-4.3 9.6-9.6 9.6m0-17.2c-4.19 0-7.6 3.41-7.6 7.6s3.41 7.6 7.6 7.6 7.6-3.41 7.6-7.6-3.41-7.6-7.6-7.6" />
        <path
          fill="none"
          d="M34.397 36.621c9.6 0 16.6 3.5 16.6 11.4 0 9.8-32 10.2-32 0 0-7.9 5.8-11.4 15.4-11.4"
        />
        <path d="M34.397 38.621q-6.75 0-10.2 2.4c-2.2 1.5-3.3 3.8-3.3 7 0 .7.3 1.3.8 1.9.6.7 1.6 1.3 2.9 1.8 2.6 1.1 6.2 1.7 10.1 1.7s7.7-.6 10.4-1.7c1.3-.5 2.3-1.2 3-1.9.6-.6.8-1.2.8-1.9 0-1.6-.3-2.9-1-4.1-.6-1.1-1.6-2.1-2.8-2.8-2.4-1.6-6.2-2.4-10.7-2.4m0-2c9.6 0 16.6 3.5 16.6 11.4 0 9.8-32 10.2-32 0 0-7.9 5.8-11.4 15.4-11.4" />
      </svg>
    </Icon>
  )
}
export default ProfileIcon
